import { IconPropsType } from '..';

export const LinkIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="11"
    height="10"
    viewBox="0 0 11 10"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8.76617 8.08571C8.76617 8.27536 8.60867 8.43286 8.41903 8.43286H2.2476C2.05474 8.43286 1.90046 8.27536 1.90046 8.08571V1.91429C1.90046 1.72143 2.05796 1.56714 2.2476 1.56714H5.77367V0.5H2.2476C1.47296 0.5 0.839742 1.12679 0.833313 1.90143V8.08571C0.833313 8.86036 1.45688 9.49036 2.23153 9.5H8.41903C9.19688 9.5 9.8301 8.87 9.83331 8.09536V4.55964H8.76617V8.08893V8.08571Z" />
    <path d="M6.65438 0.5V1.56714H8.0076L3.51081 6.06393L4.26617 6.81929L8.76296 2.3225V3.67571H9.8301V0.5H6.65117H6.65438Z" />
  </svg>
);
